import FJModalClose from '../../FJModalClose/FJModalClose.jsx';
import styles from './FJVoiceCloneEdit.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJProfileList from '../../../FJVoiceCloning/view/FJProfileList.jsx';
import FJInput from '../../../../common/components/FJInput/FJInput.jsx';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJTextToSpeechConfig from '../../../../config/appConfig/FJTextToSpeechConfig.js';
import PropTypes from 'prop-types';

const FJVoiceCloneEdit = props => {
    const { onClose, profileId, name, onChangeProfile, onChangeVoiceName, editInfo } = props;
    return (
        <div className={styles.box}>
            <FJModalClose onClick={onClose} />
            <div className={styles.title}>{FJLocalStore._('voice-info')}</div>
            <div className={styles.sub_title}>{FJLocalStore._('profile')}</div>
            <FJProfileList value={profileId} onChange={onChangeProfile} />
            <div className={styles.sub_title}>{FJLocalStore._('name')}</div>
            <FJInput
                placeholder={FJLocalStore._('please-enter-a-name')}
                onChange={onChangeVoiceName}
                value={name}
                maxLength={FJTextToSpeechConfig.NAME_MAXLENGTH}
            />
            <div className={styles.btn_box}>
                <FJButton className={styles.btn} text='cancel' onClick={onClose} />
                <FJButton className={styles.btn} text='save' type='gradient' onClick={editInfo} />
            </div>
        </div>
    );
};

FJVoiceCloneEdit.propTypes = {
    onClose: PropTypes.func,
    profileId: PropTypes.string,
    name: PropTypes.string,
    onChangeProfile: PropTypes.func,
    onChangeVoiceName: PropTypes.func,
    editInfo: PropTypes.func,
};
export default FJVoiceCloneEdit;
